// extracted by mini-css-extract-plugin
export default {"extraMargin":"lCMtBdHPYaV40eeAQIly"};